module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1l",
    attrs: {
      "id": "d7e3727"
    }
  }, [_c('b', [_vm._v("[Contents]")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d6e1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c19_r1#d7e1",
      "id": "d14e188"
    }
  }, [_vm._v("Preface ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d6e2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c20_r1#d7e2",
      "id": "d14e191"
    }
  }, [_vm._v("Acknowledgements ")])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d6e3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c21_r1#d7e3",
      "id": "d14e194"
    }
  }, [_vm._v("[One]")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0017"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c21_r1#d7e3",
      "id": "d14e197"
    }
  }, [_vm._v("The Division of Labour in the "), _c('br'), _vm._v("Family Farming Economy ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d6ee1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c21_r1#d7ee1",
      "id": "d14e202"
    }
  }, [_vm._v("Research Method: A Sociological "), _c('br'), _vm._v("Analysis of Historical Data ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d6ee2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c21_r1#d7ee2",
      "id": "d14e207"
    }
  }, [_vm._v("A Typology of Children’s Labour Contributions "), _c('br'), _vm._v("to the Operation of Prairie Farms ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d6ee3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c21_r1#d7ee3",
      "id": "d14e212"
    }
  }, [_vm._v("Outline of the Book ")])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d6e4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c22_r1#d7e4",
      "id": "d14e215",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[Two]")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0007"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c22_r1#d7e4",
      "id": "d14e218",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Attitudes Toward Child Labour and "), _c('br'), _vm._v("Children’s Assistance in "), _c('br'), _vm._v(" Pre-Production Work ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d6ee4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c22_r1#d7ee4",
      "id": "d14e226",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Labour Needs of the Pioneer Family Farm ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d6ee5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c22_r1#d7ee5",
      "id": "d14e229",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Initial Demands on Children’s Labour: Establishing "), _c('br'), _vm._v("Prairie Farms ")])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d6e5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c23_r1#d7e5",
      "id": "d14e234",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[Three]")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e4517"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c23_r1#d7e5",
      "id": "d14e237",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Productive Labour ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d6ee6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c23_r1#d7ee6",
      "id": "d14e240",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Field Work ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d6ee7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c23_r1#d7ee7",
      "id": "d14e243",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Livestock Production ")])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d6e6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c24_r1#d7e6",
      "id": "d14e246",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[Four]")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e4738"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c24_r1#d7e6",
      "id": "d14e249",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Entrepreneurial Labour ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d6ee8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c24_r1#d7ee8",
      "id": "d14e252",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paid Employment ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d6ee9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c24_r1#d7ee9",
      "id": "d14e255",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Raising Animals for Sale ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d6ee10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c24_r1#d7ee10",
      "id": "d14e258",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gopher Bounties and Trapping ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d6ee11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c24_r1#d7ee11",
      "id": "d14e262",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sales of Fruit and Other Produce ")])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d6e7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c25_r1#d7e7",
      "id": "d14e265",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[Five]")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e5028"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c25_r1#d7e7",
      "id": "d14e268",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Subsistence Labour ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d6ee12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c25_r1#d7ee12",
      "id": "d14e271",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Obtaining Water ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d6ee13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c25_r1#d7ee13",
      "id": "d14e274",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Obtaining Fuel ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d6ee14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c25_r1#d7ee14",
      "id": "d14e277",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Animal Products ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d6ee15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c25_r1#d7ee15",
      "id": "d14e280",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hunting and Fishing ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d6ee16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c25_r1#d7ee16",
      "id": "d14e283",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gardening and Harvesting "), _c('br'), _vm._v("Wild Fruits and Vegetables ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d6ee17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c25_r1#d7ee17",
      "id": "d14e288",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Protection of the Family from Insects "), _c('br'), _vm._v("and Other Animal Life ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d6ee18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c25_r1#d7ee18",
      "id": "d14e293",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Protection of the Family from Prairie Fires ")])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d6e8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c26_r1#d7e8",
      "id": "d14e296",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[Six]")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e5528"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c26_r1#d7e8",
      "id": "d14e300",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Domestic Labour ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d6ee19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c26_r1#d7ee19",
      "id": "d14e303",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gendered Roles ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d6ee20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c26_r1#d7ee20",
      "id": "d14e306",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Food Preparation ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d6ee21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c26_r1#d7ee21",
      "id": "d14e309",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Washing Clothes and Making Beds ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d6ee22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c26_r1#d7ee22",
      "id": "d14e312",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cleaning the Home and its Contents ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d6ee23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c26_r1#d7ee23",
      "id": "d14e315",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sewing, Knitting, Crocheting, "), _c('br'), _vm._v("and Other Practical Skills ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d6ee24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c26_r1#d7ee24",
      "id": "d14e320",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caring for Children ")])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d6e9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c27_r1#d7e9",
      "id": "d14e323",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[Seven]")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e5948"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c27_r1#d7e9",
      "id": "d14e326",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d6e10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c28_r1#d7e10",
      "id": "d14e329",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d6e11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c29_r1#d7e11",
      "id": "d14e332",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reference List ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d6e12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Roll_9780888645098_epub_c30_r1#d7e12",
      "id": "d14e336",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-189275ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Roll_9780888645098_epub_c18_r1.vue
// module id = 69
// module chunks = 0